<div class="loader_container">
  <ng-lottie [options]="options" />
</div>
